export default {"src":"/_next/static/media/logo-sign.22fc99c3.svg","height":112,"width":163,"blurWidth":0,"blurHeight":0};